import Icon from '../components/Icon.vue'

Icon.register({
  'radiation-alt': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M184 256H104.9C95.7 256 88 263.7 88.9 272.8 93.5 316.4 115.9 354.6 148.4 380.6 156 386.7 167.2 385.1 172.4 376.8L214.1 310C196.1 298.8 184 278.8 184 256zM281.8 201.9L323.6 135C328.5 127.2 326 116.6 317.8 112.5 296.7 102.1 273.1 96 248 96S199.3 102.1 178.1 112.5C169.9 116.6 167.5 127.2 172.3 135L214.1 201.9C223.9 195.7 235.5 192 247.9 192S272 195.7 281.8 201.9zM391.1 256H312C312 278.8 299.9 298.8 281.8 310.1L323.5 376.9C328.7 385.2 339.9 386.8 347.5 380.7 380.1 354.7 402.4 316.5 407 272.9 408.1 263.7 400.3 256 391.1 256zM248 8C111 8 0 119 0 256S111 504 248 504 496 393 496 256 385 8 248 8zM248 440C146.5 440 64 357.5 64 256S146.5 72 248 72 432 154.5 432 256 349.5 440 248 440zM248 224C230.3 224 216 238.3 216 256S230.3 288 248 288 280 273.7 280 256 265.7 224 248 224z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/radiation-alt.js
// module id = aBZ0
// module chunks = 144